import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import Version from '@/components/version';

export const Route = createFileRoute('/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isZh = currentLanguage === 'zh-TW' || currentLanguage === 'zh-CN';

  return (
    <>
      <div data-language={isZh ? 'zh' : 'en'} className="relative h-full flex flex-col">
        <Outlet />
        <Version />
      </div>
    </>
  );
}
